<ul
  class="menu min-h-full w-72 px-4 py-10 flex flex-col gap-4 justify-between relative transition-all duration-300"
  [ngClass]="{ 'lg:w-20': !settingStore.isSidebarOpen() }">
  <div class="flex flex-col gap-3.5">
    <!-- 모바일 전용 닫기 버튼 -->
    <button
      (click)="onCloseSidebar()"
      class="btn btn-ghost btn-xs flex lg:hidden rounded-full p-1 self-end hover:bg-transparent">
      <lepi-icon name="mdi:close" class="text-zinc-400" />
    </button>

    <!-- 데스크탑 전용 토글 버튼 -->
    <button
      (click)="settingStore.toggleSidebar()"
      [class.self-end]="settingStore.isSidebarOpen()"
      class="btn btn-ghost btn-xs hidden lg:flex rounded-full p-1">
      <lepi-icon
        [name]="settingStore.isSidebarOpen() ? 'mdi:chevron-double-left' : 'mdi:chevron-double-right'"
        class="text-zinc-400" />
    </button>

    @for (item of menuItems; track item.path) {
      <li>
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: item.path === '/' }"
          [class.active]="rla.isActive || isSubPathActive(item)"
          [class.bg-blue-50]="rla.isActive || isSubPathActive(item)"
          [class.rounded-xl]="rla.isActive || isSubPathActive(item)"
          [class.lg:justify-center]="!settingStore.isSidebarOpen()"
          class="group flex items-center gap-3 px-3 py-2.5">
          <lepi-icon
            [name]="item.icon"
            [class.text-[#155DFC]]="rla.isActive || isSubPathActive(item)"
            [class.text-zinc-400]="!rla.isActive && !isSubPathActive(item)" />
          <span
            [class.text-[#155DFC]]="rla.isActive || isSubPathActive(item)"
            [class.font-bold]="rla.isActive || isSubPathActive(item)"
            [class.text-zinc-500]="!rla.isActive && !isSubPathActive(item)"
            [class.font-medium]="!rla.isActive && !isSubPathActive(item)"
            [class.lg:hidden]="!settingStore.isSidebarOpen()"
            >{{ item.label }}</span
          >
        </a>
      </li>
    }
  </div>
</ul>
